import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Button, Icon } from 'semantic-ui-react';
import { isEmpty } from 'lodash';
import 'react-datepicker/dist/react-datepicker.css';
import localStore from 'store';
import { v1 as uuidv1 } from 'uuid';
import RuleSet from './RuleSet';

import './preferencesStyle.css';

class Preference extends Component {
  onAddRuleSet = e => {
    e.preventDefault();

    const preference = localStore.get('preference') || { ruleSetList: [] };
    const { ruleSetList = [] } = preference;

    const newRuleSet = {
      uid: uuidv1(),
      defaultPreferenceRuleType: '',
      items: [],
    };

    ruleSetList.push(newRuleSet);
    preference.ruleSetList = ruleSetList;
    localStore.set('preference', preference);
    this.setState({});
  };

  render() {
    const { isSubmitting } = this.props;
    const preference = localStore.get('preference') || {};

    return (
      <main>
        <Form.Group className='preferencesHeader mtb-2em'>
          <h3>Subscriptions Preferences</h3>
          <span>
            <Button color='green' inverted onClick={this.onAddRuleSet}>
              <Icon name='add' /> Add RuleSet
            </Button>
          </span>
        </Form.Group>

        <section>
          <div className='ruleSetForm'>
            {!isEmpty(preference.ruleSetList)
              && preference.ruleSetList.map((ruleSet, idx) => {
                return (
                  <Form.Group key={ruleSet.uid}>
                    <RuleSet
                      refId={ruleSet.uid}
                      id={idx}
                      parentRender={() => {
                        this.setState({});
                      }}
                      isSubmitting={isSubmitting}
                    />
                  </Form.Group>
                );
              })}
          </div>
        </section>
      </main>
    );
  }
}

Preference.propTypes = {
  isSubmitting: PropTypes.bool,
};

Preference.defaultProps = {
  isSubmitting: false,
};

export default Preference;
